import "./Footer.scss";
import defaultSetupConfiguration from "~config/defaultSetupConfiguration";
import React, { Fragment } from "react";

const menuItems = [
  {
    items: [
      {
        link: "https://synergysports.com/contact/",
        text: "Contact",
        translation: "contact",
      },
      {
        link: "https://synergyautomatedcamerasystem.zendesk.com/hc/en-us/sections/4414390198029-Synergy-Competition-Admin-User-Guide",
        text: "Support",
        translation: "support",
      },
      {
        link: "https://sportradar.com/single-sign-on-sso-privacy-notice/",
        text: "Privacy",
        translation: "privacy",
      },
      {
        link: "https://synergysports.com/terms-of-use/",
        text: "Terms",
        translation: "terms",
      },
    ],
  },
];

export const Footer = () => {
  const setup = defaultSetupConfiguration;

  const date = new Date();
  const year = date.getFullYear();

  return (
    <div className="app-footer">
      <span className="copyright">
        &copy; {year}
        {setup && setup.copyright && <React.Fragment> - {setup.copyright}</React.Fragment>}
      </span>
      {menuItems.map((item, idx) => (
        <Fragment key={idx}>
          {item.items.map((menuItem, idx) => (
            <a key={idx} href={menuItem.link} target="_blank" rel="noreferrer">
              {menuItem.text}
            </a>
          ))}
        </Fragment>
      ))}
    </div>
  )
}